"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = track;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("./constants");

var _getTrackPayload = _interopRequireDefault(require("./getTrackPayload"));

function createAction(payload) {
  return {
    type: _constants.TRACK_EVENT,
    meta: (0, _defineProperty2.default)({}, _constants.TRACK_EVENT, payload)
  };
}

function track(eventKey, eventProperties) {
  return createAction((0, _getTrackPayload.default)(eventKey, eventProperties));
}